/* eslint-disable */
import React, { useEffect, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { useDispatch } from "react-redux";
import { createClient } from "../../actions/clientActions";
import { useLocation } from "react-router-dom";
import DateFnsUtils from "@date-io/date-fns";
import { useSnackbar } from "react-simple-snackbar";
import { MenuItem, Select } from "@material-ui/core";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    backgroundColor: "#1976D2",
    marginLeft: 0,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: "white",
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const AddClient = ({ setOpen, open }) => {
  const location = useLocation();
  const [clientData, setClientData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    userId: [],
    birthday: "",
    fatherFullName: "",
    motherFullName: "",
    fatherPhone: "",
    motherPhone: "",
    defaultPhone: "",
  });
  const phones = [
    { name: "Main", value: clientData.phone },
    { name: "Father", value: clientData.fatherPhone },
    { name: "Mother", value: clientData.motherPhone },
  ].filter((item) => item.value !== "");

  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("profile"));
  // eslint-disable-next-line
  const [openSnackbar, closeSnackbar] = useSnackbar();

  useEffect(() => {
    var checkId =
      user?.result?.role === "assistant"
        ? user?.result?.userId[0]
        : user?.result?._id;
    if (checkId !== undefined) {
      setClientData({ ...clientData, userId: [checkId] });
    } else {
      setClientData({ ...clientData, userId: [user?.result?.googleId] });
    }
  }, [location]);

  const handleSubmitClient = (e) => {
    e.preventDefault();
    if (clientData.name !== "" && clientData.phone !== "") {
      dispatch(createClient(clientData, openSnackbar));
      handleClose();
      clear();
    } else {
      openSnackbar("Please fill in all fields");
    }
  };

  const clear = () => {
    setClientData({
      name: "",
      email: "",
      phone: "",
      address: "",
      userId: [],
      fatherFullName: "",
      motherFullName: "",
      fatherPhone: "",
      motherPhone: "",
      birthday: "",
      defaultPhone: "",
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const inputStyle = {
    display: "block",
    padding: "1.4rem 0.75rem",
    width: "100%",
    fontSize: "0.8rem",
    lineHeight: 1.25,
    color: "#55595c",
    backgroundColor: "#fff",
    backgroundImage: "none",
    backgroundClip: "padding-box",
    borderTop: "0",
    borderRight: "0",
    borderBottom: "1px solid #eee",
    borderLeft: "0",
    borderRadius: "3px",
    transition: "all 0.25s cubic-bezier(0.4, 0, 1, 1)",
  };

  const parentsSectionStyle = {
    border: "1px solid #ccc",
    padding: "20px",
  };

  const focus = {
    "input:focus, textarea:focus": {
      outline: "0",
      borderBottomColor: "#ffab00",
    },
  };

  return (
    <div>
      <div>
        <Dialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          fullWidth
        >
          <DialogTitle
            id="customized-dialog-title"
            onClose={handleClose}
            style={{ paddingLeft: "20px", color: "white" }}
          >
            New Customer
          </DialogTitle>
          <DialogContent dividers>
            <div className="customInputs">
              <input
                placeholder="Name"
                style={inputStyle}
                name="name"
                type="text"
                onChange={(e) =>
                  setClientData({ ...clientData, name: e.target.value })
                }
                value={clientData.name}
              />

              <input
                placeholder="Email"
                style={inputStyle}
                name="email"
                type="text"
                onChange={(e) =>
                  setClientData({ ...clientData, email: e.target.value })
                }
                value={clientData.email}
              />
              <input
                placeholder="Phone"
                style={inputStyle}
                name="phone"
                type="text"
                onChange={(e) =>
                  setClientData({ ...clientData, phone: e.target.value })
                }
                value={clientData.phone}
              />
              <input
                placeholder="Address"
                style={inputStyle}
                name="address"
                type="text"
                onChange={(e) =>
                  setClientData({ ...clientData, address: e.target.value })
                }
                value={clientData.address}
              />
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  id="date-picker-dialog"
                  label="Birth day"
                  format="MM/dd/yyyy"
                  value={clientData.birthday || new Date()}
                  onChange={(date) =>
                    setClientData({ ...clientData, birthday: date })
                  }
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
              <div style={parentsSectionStyle}>
                <h5>Parents Informations :</h5>

                <input
                  placeholder="Father FullName"
                  style={inputStyle}
                  name="fatherFullName"
                  type="text"
                  onChange={(e) =>
                    setClientData({
                      ...clientData,
                      fatherFullName: e.target.value,
                    })
                  }
                  value={clientData.fatherFullName}
                />
                <input
                  placeholder="Father phone"
                  style={inputStyle}
                  name="fatherPhone"
                  type="text"
                  onChange={(e) =>
                    setClientData({
                      ...clientData,
                      fatherPhone: e.target.value,
                    })
                  }
                  value={clientData.fatherPhone}
                />
                <input
                  placeholder="Mother FullName"
                  style={inputStyle}
                  name="motherFullName"
                  type="text"
                  onChange={(e) =>
                    setClientData({
                      ...clientData,
                      motherFullName: e.target.value,
                    })
                  }
                  value={clientData.motherFullName}
                />
                <input
                  placeholder="Mother phone"
                  style={inputStyle}
                  name="motherPhone"
                  type="text"
                  onChange={(e) =>
                    setClientData({
                      ...clientData,
                      motherPhone: e.target.value,
                    })
                  }
                  value={clientData.motherPhone}
                />
              </div>
              {phones.length > 0 && (
                <div style={{ marginTop: "20px" }}>
                  <h5>Select Default Phone :</h5>
                  <Select
                    label="Select Phone"
                    value={clientData.defaultPhone}
                    onChange={(e) => {
                      setClientData({
                        ...clientData,
                        defaultPhone: e.target.value,
                      });
                    }}
                    inputProps={{
                      name: "phone",
                      id: "phone-select",
                    }}
                  >
                    {phones.map((phoneOption, key) => (
                      <MenuItem key={key} value={phoneOption.value}>
                        {phoneOption.name} - {phoneOption.value}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
              )}
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              autoFocus
              onClick={handleSubmitClient}
              variant="contained"
              style={{ marginRight: "25px" }}
            >
              Save Customer
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default AddClient;
